import Logger from '../logger';
import pendoInit from '../../scripts/initPendo';
import dismissResourceCenter from '../../scripts/dismissResourceCenter';
import { AppConstants } from '@common';

declare global {
  interface Window {
    pendo: any,
    pendoInit: (apiKey: string) => void,
  }
}

const Pendo = {
  init(apiKey: any) {
    pendoInit(apiKey);
  },

  removeGwtMastHeadHelpIcon() {
    const oldHelpIconResourceCenter = document.querySelector(`#new-masthead .${AppConstants.MASTHEAD_RESOURCE_CENTER_SELECTOR}`) as HTMLElement;
    if (oldHelpIconResourceCenter && oldHelpIconResourceCenter.classList.contains(
      AppConstants.MASTHEAD_RESOURCE_CENTER_SELECTOR,
    )) {
      oldHelpIconResourceCenter.classList.remove(
        AppConstants.MASTHEAD_RESOURCE_CENTER_SELECTOR,
      );
    }
  },

  addDismissResourceCenterHandler() {
    dismissResourceCenter();
  },

  initialize(visitor: string, account: string, accountStatus: string) {
    if (!window.pendo) {
      Logger.log('Pendo instance not found!');
      return;
    }

    const sanitizeTransform = {
      attr: 'href',
      action: 'Replace',
      data() {
        const url = window.location.href;
        // eslint-disable-next-line no-param-reassign
        return url.replace('#', '?').replaceAll(';', '&');
      },
    };

    window.pendo.initialize({
      visitor: {
        id: visitor, // Required if user is logged in
        // email:        // Recommended if using Pendo Feedback, or NPS Email
        // full_name:    // Recommended if using Pendo Feedback
        // role:         // Optional

        // You can add any additional visitor level key-values here,
        // as long as it's not one of the above reserved names.
      },
      account: {
        id: account, // Highly recommended
        status: accountStatus,
        // name:         // Optional
        // is_paying:    // Recommended if using Pendo Feedback
        // monthly_value:// Recommended if using Pendo Feedback
        // planLevel:    // Optional
        // planPrice:    // Optional
        // creationDate: // Optional

        // You can add any additional account level key-values here,
        // as long as it's not one of the above reserved names.
      },
      location: {
        transforms: [sanitizeTransform],
      },
    });
  },

  updateOptions(account: string, accountStatus: string) {
    if (!window.pendo) {
      Logger.log('Pendo instance not found!');
      return;
    }

    window.pendo.updateOptions({
      account: {
        id: account, // Highly recommended
        status: accountStatus,
        // name:         // Optional
        // is_paying:    // Recommended if using Pendo Feedback
        // monthly_value:// Recommended if using Pendo Feedback
        // planLevel:    // Optional
        // planPrice:    // Optional
        // creationDate: // Optional

        // You can add any additional account level key-values here,
        // as long as it's not one of the above reserved names.
      },
    });
  },

  track(tagId: string, metadata: any = {}) {
    if (!window.pendo) {
      Logger.log('Pendo instance not found!');
      return;
    }

    window.pendo.track(tagId, metadata);
  },
};

export default Pendo;
